import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const FIELDS = [
  ["first_account_percent", "1re commande du proche (%)"],
  ["next_account_percent", "Commandes suivantes du proche (%)"],
  ["welcome_discount_percent", "Réduction de bienvenue du proche (%)"],
];
const inputClass = "w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-3 text-sm outline-none transition-colors focus:border-amber-deep";

export default function AdminReferralSettings() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/referral/settings").then(({ data }) => setForm(data)).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const bad = FIELDS.find(([k]) => {
      const v = parseFloat(String(form[k]).replace(",", "."));
      return Number.isNaN(v) || v < 0 || v > (k === "welcome_discount_percent" ? 50 : 100);
    });
    if (bad) {
      toast.error(`« ${bad[1]} » doit être compris entre 0 et ${bad[0] === "welcome_discount_percent" ? 50 : 100} %`);
      return;
    }
    setSaving(true);
    try {
      const payload = { enabled: form.enabled, first_guest_percent: form.first_guest_percent, next_guest_percent: form.next_guest_percent };
      FIELDS.forEach(([k]) => { payload[k] = parseFloat(String(form[k]).replace(",", ".")) || 0; });
      const { data } = await api.put("/admin/referral/settings", payload);
      setForm(data);
      toast.success("Parrainage mis à jour");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Valeurs invalides (0 à 100 %, bienvenue 50 % max)");
    } finally {
      setSaving(false);
    }
  };

  if (!form) return null;
  return (
    <form data-testid="referral-settings-form" onSubmit={save} className="rounded-2xl border border-amber-800/15 bg-white p-6 shadow-sm">
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark"><Gift size={18} className="text-honey" /> Parrainage clients</h2>
      <p className="mt-1 text-sm text-bark-soft">
        Chaque client a un lien de partage. Seuls les proches qui créent leur compte via ce lien sont parrainés : le client qui partage reçoit un pourcentage des points que leurs commandes rapportent, et le proche profite d'une réduction sur sa première commande (une seule fois). Les commandes sans compte ne rapportent rien.
      </p>
      <label className="mt-4 flex items-center gap-2 text-sm font-medium text-bark">
        <input data-testid="referral-enabled" type="checkbox" checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })} className="h-4 w-4 accent-amber-deep" />
        Parrainage actif
      </label>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="text-sm font-medium text-bark">{label}
            <input data-testid={`referral-${k}`} inputMode="decimal" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className={`${inputClass} mt-1.5`} />
          </label>
        ))}
      </div>
      <button data-testid="referral-save" disabled={saving} className="mt-4 rounded-full bg-amber-deep px-6 py-3 text-sm font-semibold text-white shadow-md shadow-amber-900/15 transition-colors hover:bg-honey disabled:opacity-60">
        {saving ? "Enregistrement…" : "Enregistrer le parrainage"}
      </button>
    </form>
  );
}
